<template>
  <ThemeProvider :color="{ middle: { 'bg-base': '#fff' }, primary: { DEFAULT: '#1896ff' } }">
    <div class="login-box rounded-sm">
      <a-form
        :model="form"
        :wrapperCol="{ span: 24 }"
        @finish="login"
        class="login-form w-[400px] p-lg xl:w-[440px] xl:p-xl h-fit text-text"
      >
        <a-divider>
          <h2>短信登录</h2>
        </a-divider>
        <a-form-item :required="true" name="mobile">
          <a-input
            v-model:value="form.mobile"
            autocomplete="new-username"
            placeholder="请输入手机号"
            size="large"
            class="login-input"
          />
        </a-form-item>
        <a-form-item :required="true" name="password">
          <a-input type="password" placeholder="请输入密码" v-model:value="form.password" />
          <!-- <a-input-search
            v-model:value="form.code"
            autocomplete="new-password"
            placeholder="请输入短信验证码"
            size="large"
            @search="getCaptcha"
            type="password"
          >
            <template #enterButton>
              <a-button :loading="sending" class="w-[136px] text-right" :disabled="sending || sended" type="primary">
                {{ sended ? '重新获取' : '获取验证码' }}
                {{ sended ? '(' + countdown + ')' : '' }}
              </a-button>
            </template>
          </a-input-search> -->
        </a-form-item>
        <a-button htmlType="submit" class="h-[40px] w-full" type="primary" :loading="loading"> 登录 </a-button>
        <a-divider></a-divider>
        <div class="terms">
          登录即代表您同意我们的
          <span class="font-bold">用户条款 </span>、<span class="font-bold"> 数据使用协议 </span>、以及
          <span class="font-bold">Cookie使用协议</span>。
        </div>
      </a-form>
    </div>
  </ThemeProvider>
</template>
<script lang="ts" setup>
  import { reactive, ref } from 'vue';
  import { useAccountStore } from '@/store';
  import { ThemeProvider } from 'stepin';
  import { message } from 'ant-design-vue';
  import JSEncrypt from 'jsencrypt';

  const encrypt = new JSEncrypt();

  const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----\n${import.meta.env.VITE_PUBLIC_KEY}\n-----END PUBLIC KEY-----`;

  encrypt.setPublicKey(PUBLIC_KEY);

  export interface LoginFormProps {
    mobile: string;
    password: string;
  }
  const loading = ref(false);
  const sending = ref(false);
  const sended = ref(false);

  const form = reactive({
    mobile: undefined,
    password: undefined,
  });

  const emit = defineEmits<{
    (e: 'success', fields: LoginFormProps): void;
    (e: 'failure', reason: string, fields: LoginFormProps): void;
  }>();

  const accountStore = useAccountStore();
  function login(params: LoginFormProps) {
    loading.value = true;
    console.log(PUBLIC_KEY);
    const encryptedText = encrypt.encrypt(params.password);
    console.log(encryptedText, '加密密码');
    accountStore
      .login(params.mobile, encryptedText as string)
      .then((res) => {
        emit('success', params);
      })
      .catch((e) => {
        console.log(e);
        emit('failure', e.msg, params);
      })
      .finally(() => (loading.value = false));
  }

  const countdown = ref(60);
  function getCaptcha() {
    if (form.mobile == null || form.mobile === '' || !/^1[3-9][0-9]{9}/.test(form.mobile)) {
      message.error('请输入正确格式手机号');
      return;
    }
    if (sended.value) {
      return;
    }
    sending.value = true;
    accountStore
      .getCaptcha(form.mobile)
      .then((res) => {
        sended.value = true;
        var intervalId = setInterval(() => {
          if (countdown.value > 0) {
            countdown.value -= 1;
          } else {
            clearInterval(intervalId);
            sended.value = false;
            countdown.value = 60;
          }
        }, 1000);
      })
      .finally(() => (sending.value = false));
  }
</script>
